const MediaCategoryEnum = {
    FREEPHOTOADVERTISEMENT: 'FreePhotoAdvertisement',
    SIGNAGEADVERTISEMENT: 'SignageAdvertisement',
    FREEPHOTOWATERMARK: 'FreePhotoWatermark',
}

export default MediaCategoryEnum;
